import { Injectable } from '@angular/core';
import {
	GET_ANTI_FRAUD_BY_PERSONAL_ID,
	GET_ANTI_FRAUD_BY_REGISTRATION_PLATES_VIN_NUMBER,
	GET_ANTI_FRAUD_VALIDITY_ACCIDENT,
	GET_ANT_FRAUD_MULTIPLE_BY_PERSONAL_ID
} from './anti-fraud-queries';
import { GraphqlService } from '../graphql/graphql.service';

@Injectable({
	providedIn: 'root'
})
export class AntiFraudService {
	GET_ANTI_FRAUD_BY_PERSONAL_ID = GET_ANTI_FRAUD_BY_PERSONAL_ID;
	GET_ANTI_FRAUD_BY_REGISTRATION_PLATES_VIN_NUMBER = GET_ANTI_FRAUD_BY_REGISTRATION_PLATES_VIN_NUMBER;
	GET_ANTI_FRAUD_VALIDITY_ACCIDENT = GET_ANTI_FRAUD_VALIDITY_ACCIDENT;
	GET_ANT_FRAUD_MULTIPLE_BY_PERSONAL_ID = GET_ANT_FRAUD_MULTIPLE_BY_PERSONAL_ID;

	constructor(private graphql: GraphqlService) {}

	getAntiFraudByPersonalId(personalId: number, yearLength: number) {
		return this.graphql.apollo.query({
			query: this.GET_ANTI_FRAUD_BY_PERSONAL_ID,
			variables: { personalId, yearLength }
		});
	}

	getAntiFraudByRegistrationPlatesVinNumber(
		registrationPlatesVinNumber: number
	) {
		return this.graphql.apollo.query({
			query: this.GET_ANTI_FRAUD_BY_REGISTRATION_PLATES_VIN_NUMBER,
			variables: { registrationPlatesVinNumber }
		});
	}

	getAntiFraudValidityAccident(registrationPlates: String, vinNumber: String) {
		return this.graphql.apollo.query({
			query: this.GET_ANTI_FRAUD_VALIDITY_ACCIDENT,
			variables: { registrationPlates, vinNumber }
		});
	}

	getAntiFraudMultipleByPersonalId(personalNumbers: number[], yearLength) {
		return this.graphql.apollo.query({
			query: this.GET_ANT_FRAUD_MULTIPLE_BY_PERSONAL_ID,
			variables: {
				personalNumbers,
				yearLength
			}
		});
	}
}
